// SPDX-License-Identifier: AGPL-3.0-or-later

import * as Modal from '@app/features/app/components/dialogs/Modal';
import styles from '@app/features/emoji/components/modals/EmojiUploadModal.module.css';
import {Spinner} from '@app/features/ui/components/Spinner';
import {plural} from '@lingui/core/macro';
import {Trans} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

interface EmojiUploadModalProps {
	count: number;
}
export const EmojiUploadModal: React.FC<EmojiUploadModalProps> = observer(({count}) => {
	const emojiText = plural(
		{count},
		{
			one: '# emoji',
			other: '# emojis',
		},
	);
	return (
		<Modal.Root size="small" centered>
			<Modal.Header title={<Trans>Uploading Emojis</Trans>} hideCloseButton />
			<Modal.Content>
				<Modal.ContentLayout className={styles.container}>
					<Spinner />
					<p className={styles.message}>
						<Trans>Uploading {emojiText}. This may take a little while.</Trans>
					</p>
				</Modal.ContentLayout>
			</Modal.Content>
		</Modal.Root>
	);
});
